module.exports = "/_next/static/images/14337aa81f7ed5e4d1fa7fea1ff8d365-nucommunity-xs@3x.jpg";